const LIST_NAMES_SKUS_KEY = '_itemListNames';

export type ListNameForSkuType = {
  sku: string;
  listName?: string;
};

export const getListNamesForSkus = () => {
  const listNamesForSkusString = window.sessionStorage.getItem(LIST_NAMES_SKUS_KEY);
  if (!listNamesForSkusString) return null;
  return JSON.parse(listNamesForSkusString) as Array<ListNameForSkuType>;
};

export const getListNamesForSku = (sku: string) => {
  const listNamesForSkusString = window.sessionStorage.getItem(LIST_NAMES_SKUS_KEY);
  if (!listNamesForSkusString) return null;
  const listNamesForSkus = JSON.parse(listNamesForSkusString) as Array<ListNameForSkuType>;
  if (sku) return listNamesForSkus?.find(item => item.sku === sku)?.listName;
  return null;
};

export const addListNameForSku = ({ sku, listName }: ListNameForSkuType) => {
  const listNamesForSkus = getListNamesForSkus() || [];
  listNamesForSkus.push({ sku, listName });
  window.sessionStorage.setItem(LIST_NAMES_SKUS_KEY, JSON.stringify(listNamesForSkus));
};

export const removeListNameForSku = (sku: string) => {
  const listNamesForSkus = getListNamesForSkus();
  if (!listNamesForSkus) return null;
  window.sessionStorage.setItem(LIST_NAMES_SKUS_KEY, JSON.stringify(listNamesForSkus.filter(item => item.sku !== sku)));
};
